export default __webpack_public_path__ + "static/media/tool-icon-shirt-orange-14.8b7ed8cb.svg";